import React, { useEffect, useState } from "react";
import { Switch, Pagination } from "antd";
import { NodeExpandOutlined } from "@ant-design/icons";
import "./index.scss";
import reflowPng from "./images/reflow.png";
import { stationApi } from "@api/newApi";
import { connect } from "react-redux";
import TimeSharingControlModal from "../../../components/TimeSharingControlModal";
import Chart from "../components/Chart";

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [aicontrol, setAicontrol] = useState(true);
  const [aicontrol1, setAicontrol1] = useState(false);
  const [show, setShow] = useState(false);
  const [dataInfo, setDataInfo] = useState({});
  const [leftChart, setLeftChart] = useState([]);
  const [rightChart, setRightChart] = useState([]);

  useEffect(() => {
    getData();
    getChartLeftData();
    getChartRightData();
  }, []);

  const getData = () => {
    stationApi.findFlowByStationId(stationId).then((res) => {
      if (res.status !== "0") return;
      const { processFlowUnitDTOList = [] } = res.data;
      const diyAttrList = processFlowUnitDTOList.flatMap(
        (item) => item.diyAttrList,
      );
      const params = {};
      diyAttrList.forEach((item) => {
        params[item.attrCode] = {
          ...item,
        };
      });
      setDataInfo(params);
    });
  };

  const onChange = () => {};

  const getChartLeftData = () => {
    stationApi.getReflowAnalyzeLeftChart().then((res) => {
      if (res.status !== "0") return;
      setLeftChart(res.data);
    });
  };

  const getChartRightData = () => {
    stationApi.getReflowAnalyzeRightChart().then((res) => {
      if (res.status !== "0") return;
      setRightChart(res.data);
    });
  };

  const showModal = () => {
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
  };

  return (
    <div className="reflow">
      <div className="dosing-controlls">
        <div className="dosing-switch">
          <div className="text">AI控制</div>
          <Switch checked={aicontrol} onChange={(e) => setAicontrol(e)} />
        </div>
        <div className="time-sharing-control">
          <div
            className="tsc-text"
            onClick={showModal}
            style={{ borderRadius: show ? "5px 0 0 5px" : "5px" }}
          >
            分时控制
            <NodeExpandOutlined />
          </div>
        </div>
      </div>

      <div className="dosing-process">
        <div className="bg">
          <img src={reflowPng} />
        </div>
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "100%",
            height: "100%",
          }}
        >
          <div
            className="custom-html"
            style={{
              left: "29%",
              top: "9%",
              height: 48,
            }}
          >
            <div className="h">1厌氧区硝化液回流瞬时流量</div>
            <div className="v">
              {dataInfo["SHC_1YYQXHYHLSSLL_1YYQXHYHLSSLL_Y"]
                ? dataInfo["SHC_1YYQXHYHLSSLL_1YYQXHYHLSSLL_Y"].value
                : ""}
              {dataInfo["SHC_1YYQXHYHLSSLL_1YYQXHYHLSSLL_Y"]
                ? dataInfo["SHC_1YYQXHYHLSSLL_1YYQXHYHLSSLL_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "29%",
              top: "18%",
              height: 48,
            }}
          >
            <div className="h">1厌氧区硝化液回流累计流量</div>
            <div className="v">
              {dataInfo["SHC_1YYQXHYHLLJLL_1YYQXHYHLLJLL_Y"]
                ? dataInfo["SHC_1YYQXHYHLLJLL_1YYQXHYHLLJLL_Y"].value
                : ""}
              {dataInfo["SHC_1YYQXHYHLLJLL_1YYQXHYHLLJLL_Y"]
                ? dataInfo["SHC_1YYQXHYHLLJLL_1YYQXHYHLLJLL_Y"].unit
                : ""}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "35.5%",
              top: "9%",
              height: 48,
            }}
          >
            <div className="h">1缺氧区硝化液回流瞬时流量</div>
            <div className="v">
              {dataInfo["SHC_1QYQXHYHLSSLL_1QYQXHYHLSSLL_Y"]
                ? dataInfo["SHC_1QYQXHYHLSSLL_1QYQXHYHLSSLL_Y"].value
                : ""}
              {dataInfo["SHC_1QYQXHYHLSSLL_1QYQXHYHLSSLL_Y"]
                ? dataInfo["SHC_1QYQXHYHLSSLL_1QYQXHYHLSSLL_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "35.5%",
              top: "18%",
              height: 48,
            }}
          >
            <div className="h">1缺氧区硝化液回流累计流量</div>
            <div className="v">
              {dataInfo["SHC_1QYQXHYHLLJLL_1QYQXHYHLLJLL_Y"]
                ? dataInfo["SHC_1QYQXHYHLLJLL_1QYQXHYHLLJLL_Y"].value
                : ""}
              {dataInfo["SHC_1QYQXHYHLLJLL_1QYQXHYHLLJLL_Y"]
                ? dataInfo["SHC_1QYQXHYHLLJLL_1QYQXHYHLLJLL_Y"].unit
                : ""}
            </div>
          </div>

          {/* <div
            className="custom-html"
            style={{
              left: "46%",
              top: "9%",
            }}
          >
            <div className="h">1#回流泵电动阀</div>
            <div
              className={
                dataInfo["SHC1_HLBDDF1_KDW_T"] &&
                dataInfo["SHC1_HLBDDF1_KDW_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["SHC1_HLBDDF1_KDW_T"] &&
              dataInfo["SHC1_HLBDDF1_KDW_T"].value == 1
                ? "开"
                : "关"}
            </div>
          </div> */}

          <div
            className="custom-html"
            style={{
              left: "46%",
              top: "19%",
            }}
          >
            <div className="h">好氧区1#DO</div>
            <div className="v">
              {dataInfo["SHC1_HYQHHYQ1_DO_Y"]
                ? dataInfo["SHC1_HYQHHYQ1_DO_Y"].value
                : ""}
              {dataInfo["SHC1_HYQHHYQ1_DO_Y"]
                ? dataInfo["SHC1_HYQHHYQ1_DO_Y"].unit
                : ""}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "46%",
              top: "25.5%",
            }}
          >
            <div className="h">好氧区1#MLSS</div>
            <div className="v">
              {dataInfo["SHC1_HYQHHYQ1_MLSS_Y"]
                ? dataInfo["SHC1_HYQHHYQ1_MLSS_Y"].value
                : ""}
              {dataInfo["SHC1_HYQHHYQ1_MLSS_Y"]
                ? dataInfo["SHC1_HYQHHYQ1_MLSS_Y"].unit
                : ""}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "28%",
              bottom: "39%",
              height: 48,
            }}
          >
            <div className="h">2厌氧区硝化液回流瞬时流量</div>
            <div className="v">
              {dataInfo["SHC_2YYQXHYHLSSLL_2YYQXHYHLSSLL_Y"]
                ? dataInfo["SHC_2YYQXHYHLSSLL_2YYQXHYHLSSLL_Y"].value
                : ""}
              {dataInfo["SHC_2YYQXHYHLSSLL_2YYQXHYHLSSLL_Y"]
                ? dataInfo["SHC_2YYQXHYHLSSLL_2YYQXHYHLSSLL_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "28%",
              bottom: "30%",
              height: 48,
            }}
          >
            <div className="h">2厌氧区硝化液回流累计流量</div>
            <div className="v">
              {dataInfo["SHC_2YYQXHYHLLJLL_2YYQXHYHLLJLL_Y"]
                ? dataInfo["SHC_2YYQXHYHLLJLL_2YYQXHYHLLJLL_Y"].value
                : ""}
              {dataInfo["SHC_2YYQXHYHLLJLL_2YYQXHYHLLJLL_Y"]
                ? dataInfo["SHC_2YYQXHYHLLJLL_2YYQXHYHLLJLL_Y"].unit
                : ""}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "35%",
              bottom: "39%",
              height: 48,
            }}
          >
            <div className="h">2缺氧区硝化液回流瞬时流量</div>
            <div className="v">
              {dataInfo["SHC_1QYQXHYHLSSLL_1QYQXHYHLSSLL_Y"]
                ? dataInfo["SHC_1QYQXHYHLSSLL_1QYQXHYHLSSLL_Y"].value
                : ""}
              {dataInfo["SHC_1QYQXHYHLSSLL_1QYQXHYHLSSLL_Y"]
                ? dataInfo["SHC_1QYQXHYHLSSLL_1QYQXHYHLSSLL_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "35%",
              bottom: "30%",
              height: 48,
            }}
          >
            <div className="h">2缺氧区硝化液回流累计流量</div>
            <div className="v">
              {dataInfo["SHC_2QYQXHYHLLJLL_2QYQXHYHLLJLL_Y"]
                ? dataInfo["SHC_2QYQXHYHLLJLL_2QYQXHYHLLJLL_Y"].value
                : ""}
              {dataInfo["SHC_2QYQXHYHLLJLL_2QYQXHYHLLJLL_Y"]
                ? dataInfo["SHC_2QYQXHYHLLJLL_2QYQXHYHLLJLL_Y"].unit
                : ""}
            </div>
          </div>
          {/* <div
            className="custom-html"
            style={{
              left: "46%",
              bottom: "23%",
            }}
          >
            <div className="h">2#回流泵电动阀</div>
            <div
              className={
                dataInfo["SHC2_HLBDDF2_KDW_T"] &&
                dataInfo["SHC2_HLBDDF2_KDW_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["SHC2_HLBDDF2_KDW_T"] &&
              dataInfo["SHC2_HLBDDF2_KDW_T"].value == 1
                ? "开"
                : "关"}
            </div>
          </div> */}
          <div
            className="custom-html"
            style={{
              left: "46%",
              bottom: "41%",
            }}
          >
            <div className="h">好氧区2#DO</div>
            <div className="v">
              {dataInfo["SHC2_HYQHHYQ2_DO_Y"]
                ? dataInfo["SHC2_HYQHHYQ2_DO_Y"].value
                : ""}
              {dataInfo["SHC2_HYQHHYQ2_DO_Y"]
                ? dataInfo["SHC2_HYQHHYQ2_DO_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "46%",
              bottom: "34.5%",
            }}
          >
            <div className="h">好氧区2#MLSS</div>
            <div className="v">
              {dataInfo["SHC2_HYQHHYQ2_MLSS_Y"]
                ? dataInfo["SHC2_HYQHHYQ2_MLSS_Y"].value
                : ""}
              {dataInfo["SHC2_HYQHHYQ2_MLSS_Y"]
                ? dataInfo["SHC2_HYQHHYQ2_MLSS_Y"].unit
                : ""}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "57%",
              top: "13%",
            }}
          >
            <div className="h">7#回流泵频率</div>
            <div className="v">
              {dataInfo["SHC1_HLB7_PLFK_Y"]
                ? dataInfo["SHC1_HLB7_PLFK_Y"].value
                : ""}
              {dataInfo["SHC1_HLB7_PLFK_Y"]
                ? dataInfo["SHC1_HLB7_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "57%",
              top: "19%",
            }}
          >
            <div className="h">8#回流泵频率</div>
            <div className="v">
              {dataInfo["SHC1_HLB8_PLFK_Y"]
                ? dataInfo["SHC1_HLB8_PLFK_Y"].value
                : ""}
              {dataInfo["SHC1_HLB8_PLFK_Y"]
                ? dataInfo["SHC1_HLB8_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "57%",
              top: "25.5%",
            }}
          >
            <div className="h">1#回流泵频率</div>
            <div className="v">
              {dataInfo["SHC1_HLB1_PLFK_Y"]
                ? dataInfo["SHC1_HLB1_PLFK_Y"].value
                : ""}
              {dataInfo["SHC1_HLB1_PLFK_Y"]
                ? dataInfo["SHC1_HLB1_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "57%",
              top: "31.5%",
            }}
          >
            <div className="h">3#回流泵频率</div>
            <div className="v">
              {dataInfo["SHC1_HLB3_PLFK_Y"]
                ? dataInfo["SHC1_HLB3_PLFK_Y"].value
                : ""}
              {dataInfo["SHC1_HLB3_PLFK_Y"]
                ? dataInfo["SHC1_HLB3_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "57%",
              top: "40.5%",
            }}
          >
            <div className="h">2#回流泵频率</div>
            <div className="v">
              {dataInfo["SHC2_HLB2_PLFK_Y"]
                ? dataInfo["SHC2_HLB2_PLFK_Y"].value
                : ""}
              {dataInfo["SHC2_HLB2_PLFK_Y"]
                ? dataInfo["SHC2_HLB2_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "57%",
              top: "46.5%",
            }}
          >
            <div className="h">4#回流泵频率</div>
            <div className="v">
              {dataInfo["SHC2_HLB4_PLFK_Y"]
                ? dataInfo["SHC2_HLB4_PLFK_Y"].value
                : ""}
              {dataInfo["SHC2_HLB4_PLFK_Y"]
                ? dataInfo["SHC2_HLB4_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "57%",
              top: "53.5%",
            }}
          >
            <div className="h">6#回流泵频率</div>
            <div className="v">
              {dataInfo["SHC2_HLB6_PLFK_Y"]
                ? dataInfo["SHC2_HLB6_PLFK_Y"].value
                : ""}
              {dataInfo["SHC2_HLB6_PLFK_Y"]
                ? dataInfo["SHC2_HLB6_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "57%",
              top: "59.5%",
            }}
          >
            <div className="h">5#回流泵频率</div>
            <div className="v">
              {dataInfo["SHC2_HLB5_PLFK_Y"]
                ? dataInfo["SHC2_HLB5_PLFK_Y"].value
                : ""}
              {dataInfo["SHC2_HLB5_PLFK_Y"]
                ? dataInfo["SHC2_HLB5_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "64%",
              top: "6.5%",
            }}
          >
            <div className="h">1#污泥泵频率</div>
            <div className="v">
              {dataInfo["SHC1_WNB1_PLFK_Y"]
                ? dataInfo["SHC1_WNB1_PLFK_Y"].value
                : ""}
              {dataInfo["SHC1_WNB1_PLFK_Y"]
                ? dataInfo["SHC1_WNB1_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "64%",
              top: "24.5%",
            }}
          >
            <div className="h">2#污泥泵频率</div>
            <div className="v">
              {dataInfo["SHC1_WNB2_PLFK_Y"]
                ? dataInfo["SHC1_WNB2_PLFK_Y"].value
                : ""}
              {dataInfo["SHC1_WNB2_PLFK_Y"]
                ? dataInfo["SHC1_WNB2_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "64%",
              top: "45.5%",
            }}
          >
            <div className="h">3#污泥泵频率</div>
            <div className="v">
              {dataInfo["SHC2_WNB3_PLFK_Y"]
                ? dataInfo["SHC2_WNB3_PLFK_Y"].value
                : ""}
              {dataInfo["SHC2_WNB3_PLFK_Y"]
                ? dataInfo["SHC2_WNB3_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "65%",
              top: "66.5%",
            }}
          >
            <div className="h">4#污泥泵频率</div>
            <div className="v">
              {dataInfo["SHC2_WNB4_PLFK_Y"]
                ? dataInfo["SHC2_WNB4_PLFK_Y"].value
                : ""}
              {dataInfo["SHC2_WNB4_PLFK_Y"]
                ? dataInfo["SHC2_WNB4_PLFK_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "55%",
              bottom: "23%",
              border: 0,
              background: "#00a3ff",
            }}
          >
            <div className="h" style={{ background: "#00a3ff" }}>
              MBR膜池回流好氧区
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "33%",
              bottom: "23%",
              border: 0,
              background: "#00a3ff",
            }}
          >
            <div className="h" style={{ background: "#00a3ff" }}>
              后好缺氧区回流厌氧区
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "36%",
              top: "40%",
              border: 0,
              background: "#00a3ff",
            }}
          >
            <div className="h" style={{ background: "#00a3ff" }}>
              后好缺氧区回流缺氧区
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              height: 50,
              left: "42%",
              bottom: "20%",
            }}
          >
            <div className="h">2污泥回流瞬时流量</div>
            <div className="v">
              {dataInfo["SHC_2WNHLSSLL_2WNHLSSLL_Y"]
                ? dataInfo["SHC_2WNHLSSLL_2WNHLSSLL_Y"].value
                : ""}
              {dataInfo["SHC_2WNHLSSLL_2WNHLSSLL_Y"]
                ? dataInfo["SHC_2WNHLSSLL_2WNHLSSLL_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              height: 50,
              left: "48%",
              bottom: "20%",
            }}
          >
            <div className="h">2污泥回流累计流量</div>
            <div className="v">
              {dataInfo["SHC_2WNHLLJLL_2WNHLLJLL_Y"]
                ? dataInfo["SHC_2WNHLLJLL_2WNHLLJLL_Y"].value
                : ""}
              {dataInfo["SHC_2WNHLLJLL_2WNHLLJLL_Y"]
                ? dataInfo["SHC_2WNHLLJLL_2WNHLLJLL_Y"].unit
                : ""}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              left: "55%",
              top: "0",
              border: 0,
              background: "#00a3ff",
            }}
          >
            <div className="h" style={{ background: "#00a3ff" }}>
              MBR膜池回流好氧区
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "33%",
              top: "2%",
              border: 0,
              background: "#00a3ff",
            }}
          >
            <div className="h" style={{ background: "#00a3ff" }}>
              后好缺氧区回流厌氧区
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              left: "36%",
              top: "32%",
              border: 0,
              background: "#00a3ff",
            }}
          >
            <div className="h" style={{ background: "#00a3ff" }}>
              后好缺氧区回流缺氧区
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              height: 50,
              left: "42%",
              top: "-2%",
            }}
          >
            <div className="h">1污泥回流瞬时流量</div>
            <div className="v">
              {dataInfo["SHC_1WNHLSSLL_1WNHLSSLL_Y"]
                ? dataInfo["SHC_1WNHLSSLL_1WNHLSSLL_Y"].value
                : ""}
              {dataInfo["SHC_1WNHLSSLL_1WNHLSSLL_Y"]
                ? dataInfo["SHC_1WNHLSSLL_1WNHLSSLL_Y"].unit
                : ""}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              height: 50,
              left: "48%",
              top: "-2%",
            }}
          >
            <div className="h">1污泥回流累计流量</div>
            <div className="v">
              {dataInfo["SHC_1WNHLLJLL_1WNHLLJLL_Y"]
                ? dataInfo["SHC_1WNHLLJLL_1WNHLLJLL_Y"].value
                : ""}
              {dataInfo["SHC_1WNHLLJLL_1WNHLLJLL_Y"]
                ? dataInfo["SHC_1WNHLLJLL_1WNHLLJLL_Y"].unit
                : ""}
            </div>
          </div>

          <div
            className="custom-html"
            style={{
              right: "25%",
              top: "10%",
              height: 50,
            }}
          >
            <div className="h">1#污泥泵电动阀开到位</div>
            <div
              className={
                dataInfo["SHC1_WNBDDF1_KDW_T"] &&
                dataInfo["SHC1_WNBDDF1_KDW_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["SHC1_WNBDDF1_KDW_T"] &&
              dataInfo["SHC1_WNBDDF1_KDW_T"].value == 1
                ? "开"
                : "关"}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              right: "24.5%",
              top: "19%",
              height: 50,
            }}
          >
            <div className="h">2#污泥泵电动阀开到位</div>
            <div
              className={
                dataInfo["SHC1_WNBDDF2_KDW_T"] &&
                dataInfo["SHC1_WNBDDF2_KDW_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["SHC1_WNBDDF2_KDW_T"] &&
              dataInfo["SHC1_WNBDDF2_KDW_T"].value == 1
                ? "开"
                : "关"}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              right: "23%",
              top: "50%",
              height: 50,
            }}
          >
            <div className="h">3#污泥泵电动阀开到位</div>
            <div
              className={
                dataInfo["SHC2_WNBDDF3_KDW_T"] &&
                dataInfo["SHC2_WNBDDF3_KDW_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["SHC2_WNBDDF3_KDW_T"] &&
              dataInfo["SHC2_WNBDDF3_KDW_T"].value == 1
                ? "开"
                : "关"}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              right: "23%",
              top: "59%",
              height: 50,
            }}
          >
            <div className="h">4#污泥泵电动阀开到位</div>
            <div
              className={
                dataInfo["SHC2_WNBDDF4_KDW_T"] &&
                dataInfo["SHC2_WNBDDF4_KDW_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["SHC2_WNBDDF4_KDW_T"] &&
              dataInfo["SHC2_WNBDDF4_KDW_T"].value == 1
                ? "开"
                : "关"}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              right: "28%",
              top: "34%",
            }}
          >
            <div className="h">1#出水闸门</div>
            <div
              className={
                dataInfo["SHC1_CSZM1_KDW_T"] &&
                dataInfo["SHC1_CSZM1_KDW_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["SHC1_CSZM1_KDW_T"] &&
              dataInfo["SHC1_CSZM1_KDW_T"].value == 1
                ? "开"
                : "关"}
            </div>
          </div>
          <div
            className="custom-html"
            style={{
              right: "23%",
              top: "42%",
            }}
          >
            <div className="h">2#出水闸门</div>
            <div
              className={
                dataInfo["SHC2_CSZM2_KDW_T"] &&
                dataInfo["SHC2_CSZM2_KDW_T"].value == 1
                  ? "v success"
                  : "v error"
              }
            >
              {dataInfo["SHC2_CSZM2_KDW_T"] &&
              dataInfo["SHC2_CSZM2_KDW_T"].value == 1
                ? "开"
                : "关"}
            </div>
          </div>
        </div>
      </div>
      <div className="dosing-chart-ai">
        <div
          className="dosing-chart"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Chart
            chartTitle="智能回流"
            chartData={leftChart}
            id="reflowLeftChart"
            width="48%"
            height="100%"
          />
          <Chart
            chartTitle="智能回流"
            chartData={rightChart}
            id="reflowRightChart"
            width="48%"
            height="100%"
          />
        </div>
        <div className="dosing-ai">
          <div className="dosing-switch">
            <div className="text">AI窗口会话</div>
            <Switch checked={aicontrol1} onChange={(e) => setAicontrol1(e)} />
          </div>
          <div className="dosing-ai-list">
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dosing-report">
        <div className="dosing-report-title">智能回流分析报告</div>
        <div className="dosing-report-content">
          <div className="dosing-report-head">
            <div>生成时间</div>
            <div>报告名称</div>
            <div>报告摘要</div>
            <div>操作</div>
          </div>
          <div className="dosing-report-body">
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能回流分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能回流分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能回流分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能回流分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能回流分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
          </div>

          <div className="dosing-report-pages">
            <Pagination
              showQuickJumper
              defaultCurrent={1}
              total={100}
              onChange={onChange}
              showTotal={(total) => `总共${total}条`}
            />
          </div>
        </div>
      </div>
      {show && (
        <TimeSharingControlModal
          visible={show}
          controllType={3}
          onCancel={closeModal}
        />
      )}
    </div>
  );
});
